import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

const Container = styled('section')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '2rem 0',

  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.colors.gray.primary}`,
  },

  '&:not(:first-of-type)': {
    paddingBottom: '2rem',
  },

  [mediaQueryBuilder(theme.mediaQueries.max.width['768'])]: {
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

export default Container;
